import React from 'react';
import Modal from 'components/commons/modal/Modal';
import Icon from 'components/commons/icon/Icon';

export const DataCooperationModal = ({
  hideModal,
  isShowModal,
}: {
  isShowModal: boolean;
  hideModal: () => void;
}): React.ReactElement => {
  return (
    <Modal isShow={isShowModal} close={hideModal}>
      <div className="p-4">
        <div className="flex flex-row">
          <Icon name="alert" className="flex items-center h-5 text-red pr-2" />
          <div className="text-base font-bold">データ取得中です</div>
          <div
            className="icon-close ml-auto text-gray-500 text-2xl cursor-pointer"
            onClick={hideModal}
          />
        </div>
        <div className="mt-3 mb-2 text-sm">
          <div>
            <div>データの反映までお待ちください。</div>
            <div>最大1〜2営業日ほどかかる場合があります。</div>
          </div>

          <div className="mt-2">
            <div>なお、データ取得中の銘柄情報は</div>
            <div>　・レポート</div>
            <div>　・ポートフォリオ分析</div>
            <div>には反映されません。データ取得完了後にご確認ください。</div>
          </div>
        </div>
        <div
          onClick={hideModal}
          className="flex justify-center text-gray-500 m-1 p-2 text-base cursor-pointer">
          閉じる
        </div>
      </div>
    </Modal>
  );
};
